import React from 'react'

const SongsScreen = () => {
  return (
    <div>Songs</div>
  )
}

export default SongsScreen